import {
  XTD_CURRENCY_CODE,
  XUC_CURRENCY_CODE,
} from '@packages/domain/constants/currency';
import type { Currency } from '@packages/domain/models/currency';

export const getCurrencyDisplayName = (
  currency: Currency | undefined,
): string => {
  if (!currency) {
    return '';
  }

  const { code, symbol } = currency;

  if (isStablecoin(code)) {
    return symbol;
  }

  return code;
};

export const isStablecoin = (currencyCode: string | undefined): boolean => {
  const stablecoins = [XUC_CURRENCY_CODE, XTD_CURRENCY_CODE];
  return currencyCode ? stablecoins.includes(currencyCode) : false;
};
